"use client";
import useWindowSize from "@/helpers/hooks/useWindowSize";
import { Button } from "@nextui-org/react";
import React, { useEffect, useState } from "react";

const CustomButton = ({
  label,
  variant,
  color,
  textColor,
  leftIcon,
  rightIcon,
  fullWidth,
  onClick,
  classNames,
  isLoading,
  disabled,
  showLabelOnLoading,
  type = "button",
}) => {
  const [size, setSize] = useState("md");
  const device = useWindowSize();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setSize("sm");
      } else {
        setSize("md");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Button
      startContent={rightIcon}
      endContent={leftIcon}
      size={size}
      isLoading={isLoading}
      color={color}
      disableRipple
      variant={variant}
      className={`${classNames} ${textColor} rounded-full font-semibold`}
      fullWidth={fullWidth}
      onPress={onClick}
      isDisabled={disabled}
      type={type}
    >
      {isLoading && showLabelOnLoading && label}
      {!isLoading && label}
    </Button>
  );
};

export default CustomButton;
